import { render, staticRenderFns } from "./IP_HCCSummary.vue?vue&type=template&id=245fb5f8&scoped=true&"
import script from "./IP_HCCSummary.vue?vue&type=script&lang=js&"
export * from "./IP_HCCSummary.vue?vue&type=script&lang=js&"
import style0 from "./IP_HCCSummary.vue?vue&type=style&index=0&id=245fb5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245fb5f8",
  null
  
)

export default component.exports